<template>

    <div id="wrapper">

        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

        <transition name="dim">
            <div v-if="showModal" class="modal-backdrop" @click="hideModal"></div>
        </transition>

    </div>

</template>

<style scoped lang="scss">

    #wrapper {
        height: 100%;
        min-height: 100%;
    }

</style>

<script>

export default {

    watch: {

        showModal(val) {
            let wrapper = document.getElementById('wrapper');
            if (val) {
                document.body.classList.add('modal-open');
                if (wrapper.scrollHeight > wrapper.clientHeight) {
                    wrapper.style.padding = '0 15px 0 0';
                }
            } else {
                document.body.classList.remove('modal-open');
                wrapper.style.padding = '0';
            }
        },

    },

    methods: {

        hideModal() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>